import createAction from '../createAction'

export const addMessage = createAction('add line')
